import { render, staticRenderFns } from "./SpendProyectoMantenimiento.vue?vue&type=template&id=83c58b9e&"
import script from "./SpendProyectoMantenimiento.vue?vue&type=script&lang=js&"
export * from "./SpendProyectoMantenimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports